export default "__VITE_ASSET__0f691f46__"